import { Input as KeychaineInput, InputLeftAddon } from '@chakra-ui/react';
import { AsYouType } from 'libphonenumber-js';
import React, { useCallback, useEffect } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { Box, FormControl, FormLabel, FormWarning, InputGroup } from '../..';
const defaultCountryCode = '+1';
export function PhoneInput({ name, control, labelText, errors, ...rest }) {
    const { setValue, getValues } = useFormContext();
    const handleChange = useCallback((value) => {
        const cleanedTarget = value?.replace(/[()-]|\s/g, '');
        setValue('cleanedInput', cleanedTarget);
        const formattedPhoneNumber = (value?.length > 5 && new AsYouType('US').input(value)) || value;
        setValue(name, formattedPhoneNumber);
        setValue('countryCode', defaultCountryCode);
    }, [setValue, name]);
    useEffect(() => {
        const initialValue = getValues('phone');
        if (initialValue) {
            handleChange(initialValue);
        }
    }, [getValues, handleChange]);
    return (React.createElement(Box, null,
        React.createElement(Controller, { render: ({ field }) => (React.createElement(FormControl, null,
                labelText && (React.createElement(FormLabel, { id: name + 'label', key: name + 'label' }, labelText)),
                React.createElement(InputGroup, { size: rest.size ? rest.size : undefined },
                    React.createElement(InputLeftAddon, null, defaultCountryCode),
                    React.createElement(KeychaineInput, { ...field, type: "phone", country: "US", onChange: (e) => handleChange(e?.target?.value), ...rest, isInvalid: errors[name] && true })))), name: name, control: control }),
        errors[name] && React.createElement(FormWarning, null, errors[name].message)));
}
